<template>
  <div>

    <div class="form-row">
      <div class="form-group col-md-6">
        <label>บัญชีแสดงสัญญา 
          <!-- <span class="text-white">Nx-MEA_5</span> -->
        </label>
        <input 
        v-model="caNo" 
        name="caNo" 
        v-validate="{required:true,max:20}"
        :class="{'input': true, 'is-danger': errors.has('caNo') }"
        type="number" class="form-control" placeholder="">
        <span
        v-show="errors.has('caNo')"
        class="help is-danger"
        >กรอก บัญชีแสดงสัญญา</span>        
      </div>
      <div class="form-group col-md-6">
        <label>เครื่องวัดหน่วยไฟฟ้า</label>
        <input 
        v-model="meterNo" 
        name="meterNo" 
        v-validate="{required:true,max:20}"        

        :class="{'input': true, 'is-danger': errors.has('meterNo') }"
        type="number" class="form-control" placeholder="">
        <span
        v-show="errors.has('meterNo')"
        class="help is-danger"
        >กรอก เครื่องวัดหน่วยไฟฟ้า</span>     

      </div>
    </div>

  </div>
</template>

<script>
export default {
  inject: ['$validator'],
  props: ["reqType","appVo"],
  data() {
    return {
      caNo: this.appVo.caNo,
      meterNo: this.appVo.meterNo,
    };
  },
  mounted() {
    // initial ค่ากรณีที่เป็น ต่ออายุและ เพิ่มวงเงิน
    if(this.appVo){
      this.caNo = this.appVo.caNo;
      this.meterNo = this.appVo.meterNo;

      this.$emit("childExtToParent", {
          caNo: this.caNo,
          meterNo: this.meterNo,
        });
    }
  },  
  watch: {
    caNo(newVal, oldVal) {
      console.log("newVal : "+newVal);
      if(newVal.substring(0, 2)=="90"){
        this.meterNo = "";
      }
      this.$emit("childExtToParent", {
        caNo: this.caNo,
        meterNo: this.meterNo,
      });
    },
    meterNo(newVal, oldVal) {
      this.$emit("childExtToParent", {
        caNo: this.caNo,
        meterNo: this.meterNo,
      });
    },
  },
};
</script>